const VALID_WINDOWS = [90, 180] as const;
const DEFAULT_WINDOW = 90 satisfies AvailabilityWindow;

const isAvailabilityWindow = (value: number): value is AvailabilityWindow =>
  VALID_WINDOWS.some((window) => window === value);

export const MAX_AVAILABILITY_WINDOW_DAYS =
  VALID_WINDOWS[VALID_WINDOWS.length - 1];

export type AvailabilityWindow = (typeof VALID_WINDOWS)[number];

export const resolveAvailabilityWindow = (
  flagValue?: string | boolean,
): AvailabilityWindow => {
  const parsedValue = Number(flagValue);

  if (isAvailabilityWindow(parsedValue)) {
    return parsedValue;
  }

  return DEFAULT_WINDOW;
};
